import DirectionInput from "components/Properties/InputComponents/DirectionInput";
import TextureLibraryInput from "components/Properties/InputComponents/TextureLibraryInput";
import BaseComponent from "../BaseComponent";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";

const TextureComponent = ({selectedObject, transformOnChange, inputOnChange, checkboxOnChange}) => {
  const {material} = selectedObject;
  const hasMeshTexture = selectedObject?.userData?.map || selectedObject?.userData?.normalMap || selectedObject?.userData?.envMap;

  return (
    <BaseComponent title="Texture" foldable={true}>
      {hasMeshTexture && (
        <>
          <DirectionInput
            name="Offset"
            value={{
              x: material.map?.offset.x,
              y: material.map?.offset.y,
            }}
            transformOnChange={transformOnChange}
            is2D={true}
          />
          <DirectionInput
            name="Repeat"
            value={{
              x: material.map?.repeat.x,
              y: material.map?.repeat.y,
            }}
            transformOnChange={transformOnChange}
            is2D={true}
          />
          <NumberSliderInput name="Rotation" value={material.map?.rotation} min={0} max={360} step={1} inputOnChange={inputOnChange} />
        </>
      )}
      <ToggleInput name="Map" checked={selectedObject.userData.hasMap} checkboxOnChange={checkboxOnChange} />
      <TextureLibraryInput name="Map" propertyName="map" inputOnChange={inputOnChange} thumbnail={selectedObject.userData?.map} />
      <ToggleInput name="Normal Map" checked={selectedObject.userData.hasNormalMap} checkboxOnChange={checkboxOnChange} />
      <TextureLibraryInput
        name="Normal Map"
        propertyName="normalMap"
        inputOnChange={inputOnChange}
        thumbnail={selectedObject.userData?.normalMap}
      />
      {/* <TextureToggleInput
        name="Env Map"
        propertyName="envMap"
        inputOnChange={inputOnChange}
        checkboxOnChange={checkboxOnChange}
        checked={selectedObject.userData.hasEnvMap}
        thumbnail={selectedObject.userData?.envMap}
      /> */}
    </BaseComponent>
  );
};

export default TextureComponent;
